// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__fRvZQ","noInteraction":"EventWrapper_noInteraction__1L8gX","pointerPassthrough":"EventWrapper_pointerPassthrough__6Lfsg"};